/**
 * @file Timeline Item component
 * @author Willem Jan Weitering
 */
import { OnInit } from '@angular/core';
import { LocalisationService } from '../../core/localisation.service';
import { TimelineService } from '../timeline.service';
import { TimelineItemType } from '../helpers/timelineItem-type.enum';
import * as moment from 'moment';
/**
 * This is a base component that shows an item in the timeline.
 */
var TimelineItemBaseComponent = /** @class */ (function () {
    /**
     * Constructs a TimelineItem Component
     */
    function TimelineItemBaseComponent(timelineService, localisationService) {
        this.timelineService = timelineService;
        this.localisationService = localisationService;
        /* allows you to use TimelineItemType enum in template */
        this.TimelineItemType = TimelineItemType;
        /* Contains the item data */
        this.item = undefined;
    }
    /** takes a Date and returns a short date string */
    TimelineItemBaseComponent.prototype.valueAsDate = function (time) {
        if (!moment.isDate(time)) {
            return null;
        }
        var format = this.localisationService.dayMonth;
        // return moment(time).format("D MMM").toLowerCase();
        return moment(time).format(format.format).toLowerCase();
    };
    /** takes a Date and returns a short time string */
    TimelineItemBaseComponent.prototype.valueAsTime = function (time) {
        if (!moment.isDate(time)) {
            return null;
        }
        var format = this.localisationService.time;
        // return moment(time).format("H:mm");
        return moment(time).format(format.format);
    };
    /**
     * Is called directly after the creation of this component
     */
    TimelineItemBaseComponent.prototype.ngOnInit = function () {
    };
    return TimelineItemBaseComponent;
}());
export { TimelineItemBaseComponent };
